import { Box, Typography } from "@mui/material";
import { t } from "i18next";
import ProjectHeader from "../../components/new/ProjectHeader";
import TrainHistory from "../../components/train/TrainHistory";

export default function ProjectHistoryPage() {
  return (
    <>
      <div className="h-full overflow-auto">
        <Box
          sx={{
            width: "1200px",
            display: "flex",
            flexDirection: "column",
            // alignItems: "center",
            gap: 2,
            p: 3,
          }}
        >
          <Typography variant="h4">{t("History")}</Typography>
          <TrainHistory />
        </Box>
      </div>
    </>
  );
}
